export interface PasswordRule {
  id: string;
  label: string;
  test: (password: string) => boolean;
}

export const PASSWORD_RULES: PasswordRule[] = [
  { id: 'length', label: 'At least 8 characters', test: (p) => p.length >= 8 },
  { id: 'upper', label: 'One uppercase letter', test: (p) => /[A-Z]/.test(p) },
  { id: 'lower', label: 'One lowercase letter', test: (p) => /[a-z]/.test(p) },
  { id: 'digit', label: 'One number', test: (p) => /\d/.test(p) },
  {
    id: 'special',
    label: 'One special character (!@#$%&*)',
    test: (p) => /[!@#$%^&*]/.test(p),
  },
];

export function isPasswordValid(password: string): boolean {
  return PASSWORD_RULES.every((rule) => rule.test(password));
}

export function passwordValidationError(password: string): string | null {
  if (!password.trim()) return 'Password is required';
  const failed = PASSWORD_RULES.filter((rule) => !rule.test(password));
  if (!failed.length) return null;
  return `Password must include: ${failed.map((r) => r.label.toLowerCase()).join(', ')}`;
}

function pickRandom(chars: string): string {
  return chars[Math.floor(Math.random() * chars.length)];
}

function shuffle(values: string[]): string[] {
  const arr = [...values];
  for (let i = arr.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

export function generateSuggestedPassword(length = 16): string {
  const upper = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
  const lower = 'abcdefghjkmnpqrstuvwxyz';
  const digits = '23456789';
  const special = '!@#$%&*';
  const all = upper + lower + digits + special;

  const required = [
    pickRandom(upper),
    pickRandom(lower),
    pickRandom(digits),
    pickRandom(special),
  ];
  const rest = Array.from({ length: Math.max(length, 12) - required.length }, () =>
    pickRandom(all),
  );
  return shuffle([...required, ...rest]).join('');
}
